<template>
  <div class="mt-2">
    <label for="language-selector" class="block text-sm font-medium text-gray-700">Idioma</label>
    <a-select
      id="language-selector"
      :default-value="internalValue"
      @change="onUpdate"
      :mode="mode"
      class="mt-1 block w-full"
      placeholder="Selecciona un idioma"
    >
      <a-select-option v-for="(language, index) in languages" :key="index" :value="language.shortName">
        <span>{{ language.icon }} {{ language.shortName }} - {{ language.longName }}</span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    mode: {
      type: String,
      default: 'default'
    },
    value: {
      type: Object,
      default: () => ({ code: 'en', shortName: 'EN', longName: 'Inglés (English)', icon: '🇬🇧' })
    }
  },
  computed: {
    internalValue () {
      return this.value.shortName || null
    }
  },
  data () {
    return {
      languages: [
        { code: 'en', shortName: 'EN', longName: 'Inglés (English)', icon: '🇬🇧' },
        { code: 'zh', shortName: 'ZH', longName: 'Chino (中文)', icon: '🇨🇳' },
        { code: 'es', shortName: 'ES', longName: 'Español (Español)', icon: '🇪🇸' },
        { code: 'hi', shortName: 'HI', longName: 'Hindi (हिन्दी)', icon: '🇮🇳' },
        { code: 'ar', shortName: 'AR', longName: 'Árabe (العربية)', icon: '🇸🇦' },
        { code: 'bn', shortName: 'BN', longName: 'Bengalí (বাংলা)', icon: '🇧🇩' },
        { code: 'pt', shortName: 'PT', longName: 'Portugués (Português)', icon: '🇵🇹' },
        { code: 'ru', shortName: 'RU', longName: 'Ruso (Русский)', icon: '🇷🇺' },
        { code: 'ja', shortName: 'JA', longName: 'Japonés (日本語)', icon: '🇯🇵' },
        { code: 'de', shortName: 'DE', longName: 'Alemán (Deutsch)', icon: '🇩🇪' },
        { code: 'fr', shortName: 'FR', longName: 'Francés (Français)', icon: '🇫🇷' },
        { code: 'it', shortName: 'IT', longName: 'Italiano (Italian)', icon: '🇮🇹' },
        { code: 'ko', shortName: 'KO', longName: 'Coreano (한국어)', icon: '🇰🇷' },
        { code: 'vi', shortName: 'VI', longName: 'Vietnamita (Tiếng Việt)', icon: '🇻🇳' },
        { code: 'th', shortName: 'TH', longName: 'Tailandés (ภาษาไทย)', icon: '🇹🇭' },
        { code: 'tr', shortName: 'TR', longName: 'Turco (Türkçe)', icon: '🇹🇷' },
        { code: 'pl', shortName: 'PL', longName: 'Polaco (Polski)', icon: '🇵🇱' },
        { code: 'nl', shortName: 'NL', longName: 'Holandés (Nederlands)', icon: '🇳🇱' },
        { code: 'sv', shortName: 'SV', longName: 'Sueco (Svenska)', icon: '🇸🇪' },
        { code: 'el', shortName: 'EL', longName: 'Griego (Ελληνικά)', icon: '🇬🇷' }
      ]
    }
  },
  methods: {
    onUpdate (value) {
      const selectedRecord = this.languages.find(record => record.shortName === value)
      this.$emit('change', selectedRecord)
    }
  }
}
</script>
